// Utilities
import baseAxios from "./base"

const AdminApi = {
  validate: () => {
    return baseAxios.post("/auth/validate", {})
  },

  login: params => {
    return baseAxios.post("/auth/login", params)
  },

  signup: params => {
    // return Promise.reject({ status: 401, response: { data: [0 })
    return baseAxios.post("/auth/signup", params)
  },

  logout: () => {
    return baseAxios.post("/auth/logout", {})
  },

  forgotPassword: params => {
    return baseAxios.post("/auth/passwords/forgot", params)
  },

  resetPassword: params => {
    return baseAxios.post("/auth/passwords/reset", params)
  },

  subscribe: params => {
    return baseAxios.post("/auth/subscribe", params)
  },
}

export default AdminApi
